import React from 'react';
import moment from 'moment-timezone';
import groupBy from 'lodash.groupby';
import { TitleStyles } from './styles';
import { Search } from '../types';

function GetDateInCurrentTimeZone(date: any) {
  const browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const utcDate = moment.tz(date, 'Universal');
  return moment(utcDate).tz(browserTZ);
}
interface Props {
  searches: Search[];
}
const SearchesDelivered = (props: Props) => {
  const groupedByDate = () => {
    return groupBy(
      props.searches.filter((s) => s.searchStatusType === 'Completed'),
      'lastUpdated');
  }
  const dateGrouped = groupedByDate();
  return (
    <div>
      <>
        {Object.keys(dateGrouped).length > 0 && (
          <>
            <TitleStyles style={{ width: 200, marginTop: 24 }}>
              Searches Delivered
            </TitleStyles>
            {Object.keys(dateGrouped).map((key) => {
              return (
                <div
                  style={{ display: 'flex', flexWrap: 'wrap', marginTop: 12 }}
                >
                  <div style={{ marginRight: 6 }}>
                    {GetDateInCurrentTimeZone(key).format('MM/DD/YYYY')}:{' '}
                  </div>
                  {dateGrouped[key].map((s, i, arr) => {
                    return (
                      <div style={{ marginRight: 6 }}>{`${s.searchTypeTruncated}${i !== arr.length - 1 ? ',' : ''}`}</div>
                    );
                  })}
                </div>
              );
            })}
          </>
        )}
      </>
    </div>
  );
};

export default SearchesDelivered;
